import { mergeMap, switchMap } from 'rxjs';
import { withLatestFrom } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { IClientApiDependencySegment, catchApiError } from '@cbridge-packages/api';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { IGetSelectorStateType } from '@cbridge-utils/reselect';
import { AdjustmentProfileAction } from '../adjustmentProfile.action';
import { AdjustmentProfileTranslator } from '../adjustmentProfile.translator';
import { adjustmentProfileStoreSelector } from '../adjustmentProfile.selector';

type IState = IGetSelectorStateType<typeof adjustmentProfileStoreSelector>;

export const updateAdjustmentEpic: IEpic<IState, IClientApiDependencySegment> = (action$, state$, dependencies) => action$.pipe(
  isTypeOfAndGetPayload(AdjustmentProfileAction.update.started),
  withLatestFrom(state$),
  switchMap(([params, state]) => {
    const { reject } = params;

    return dependencies.api.updateAdjustmentProfile(AdjustmentProfileTranslator.toApi(params)).pipe(
      mergeMap(() => {
        const adjustmentProfileData = { ...adjustmentProfileStoreSelector(state).data };
        adjustmentProfileData[params.adjustmentId] = params;

        return [AdjustmentProfileAction.update.done({ result: adjustmentProfileData, params })];
      }),
      catchApiError((error) => {
        const isHandled = reject?.(error.errorCode, error.description, error.params);
        return [
          AdjustmentProfileAction.update.failed({ error: null, params }),
          ...(isHandled ? [] : [createApiErrorNotification(error)]),
        ];
      }),
    );
  }),
);
